import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { SEO } from '@/components/SEO';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO
        title={t('seo.notFound.title')}
        description={t('seo.notFound.description')}
        noindex={true}
      />
      <Header />
      <main className="flex-1 flex items-center justify-center py-16 sm:py-24 px-4" data-testid="not-found-page">
        <div className="max-w-xl w-full text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-accent/10 text-accent mb-8">
            <Compass className="w-10 h-10" strokeWidth={1.75} />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-primary tracking-tight">
            {t('notFound.title')}
          </h1>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            {t('notFound.body')}
          </p>
          <div className="mt-10">
            <Link to="/" data-testid="not-found-home-button">
              <button className="btn-primary inline-flex items-center gap-2 text-sm sm:text-base py-3 px-6">
                <ArrowLeft className="w-4 h-4" />
                {t('notFound.backHome')}
              </button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
